<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <h4 class="card-title">Relatórios</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Expande a tela"
                      v-if="!isFullscreen"
                      ><i class="ft-maximize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="expandFullscreen()"
                      v-b-tooltip
                      title="Minimiza a tela"
                      v-if="isFullscreen"
                      ><i class="ft-minimize"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onFilterShowHide()"
                      v-b-tooltip.hover.left="'Filtros'"
                      ><i class="fa fa-filter"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table">
                <div class="box-typical-body">
                  <div class="container-fluid">
                    <div class="row loadingDataPosition">
                      <div class="loadingData" v-if="loading">
                        <div class="loadingDataSpinner">
                          <spinner
                            v-if="loading"
                            text-fg-color="#ffffff"
                            message="Carregando..."
                          ></spinner>
                        </div>
                      </div>
                      <div class="container-fluid">
                        <h5>Relatório Frete Recebido/Expedido</h5>
                        <b-row no-gutters>
                          <b-col sm="6" md="2" class="p-0">
                            <b-form-datepicker
                              locale="pt-br"
                              reset-button
                              placeholder="Data Cte Inicial"
                              v-model="form.dt_ini"
                              class="form-control"
                              :date-format-options="{
                                day: 'numeric',
                                month: 'numeric',
                                year: 'numeric',
                              }"
                              @keyup.enter="doFilter"
                            >
                            </b-form-datepicker>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <b-form-datepicker
                              locale="pt-br"
                              reset-button
                              placeholder="Data Cte Final"
                              v-model="form.dt_fim"
                              class="form-control"
                              :date-format-options="{
                                day: 'numeric',
                                month: 'numeric',
                                year: 'numeric',
                              }"
                              @keyup.enter="doFilter"
                            >
                            </b-form-datepicker>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <b-form-datepicker
                              locale="pt-br"
                              reset-button
                              placeholder="Data de Expedição Inicial"
                              v-model="form.dt_expedicao_ini"
                              class="form-control"
                              :date-format-options="{
                                day: 'numeric',
                                month: 'numeric',
                                year: 'numeric',
                              }"
                              @keyup.enter="doFilter"
                            >
                            </b-form-datepicker>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <b-form-datepicker
                              locale="pt-br"
                              reset-button
                              placeholder="Data de Expedição Final"
                              v-model="form.dt_expedicao_fim"
                              class="form-control"
                              :date-format-options="{
                                day: 'numeric',
                                month: 'numeric',
                                year: 'numeric',
                              }"
                              @keyup.enter="doFilter"
                            >
                            </b-form-datepicker>
                          </b-col>
                          <b-col sm="6" md="4" class="p-0">
                            <!-- <label>Tabela de frete</label> -->
                            <multiselect
                              v-model="unidades"
                              :options="this.unidades2"
                              track-by="value"
                              label="label"
                              :multiple="true"
                              group-values="unidade"
                              group-label="descr"
                              :group-select="true"
                              :clear-on-select="false"
                              :hide-selected="true"
                              placeholder="Unidade"
                              tag-placeholder=""
                              select-label=""
                              selected-label="Selecionado"
                              deselect-label="Remover"
                              selectGroupLabel="Adicionar todas Unidades"
                              deselectGroupLabel="Remover todas Unidades"
                            ></multiselect>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <!-- <label>Tabela de frete</label> -->
                            <multiselect
                              v-model="origemSelected"
                              :options="optionsMunicipio"
                              track-by="value"
                              label="label"
                              :clear-on-select="false"
                              :hide-selected="true"
                              placeholder="Origem"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                            ></multiselect>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <!-- <label>Tabela de frete</label> -->
                            <multiselect
                              v-model="destinoSelected"
                              :options="optionsMunicipio"
                              track-by="value"
                              label="label"
                              :clear-on-select="false"
                              :hide-selected="true"
                              placeholder="Destino"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                            ></multiselect>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <!-- <label>Tabela de frete</label> -->
                            <multiselect
                                v-model="tpProcessoSelected"
                                :options="optionsLivTpProcesso"
                                track-by="value"
                                label="label"
                                :clear-on-select="false"
                                :hide-selected="true"
                                placeholder="Tipo processo"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                            ></multiselect>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <!-- <label>Tabela de frete</label> -->
                            <multiselect
                                v-model="tpOperacaoSelected"
                                :options="optionsLivTpOperacao"
                                track-by="value"
                                label="label"
                                :clear-on-select="false"
                                :hide-selected="true"
                                placeholder="Tipo operação"
                                tag-placeholder="Selecionar"
                                select-label="Selecionar"
                                selected-label="Selecionado"
                                deselect-label="Remover"
                            ></multiselect>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <!-- <label>Tabela de frete</label> -->
                            <multiselect
                              v-model="faturaSelected"
                              :options="optionsLivStatusFatura"
                              track-by="value"
                              label="label"
                              :clear-on-select="false"
                              :hide-selected="true"
                              placeholder="Status Fatura"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                            ></multiselect>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <!-- <label>Tabela de frete</label> -->
                            <multiselect
                              v-model="statusCargaSelected"
                              :options="optionsStatusCarga"
                              track-by="value"
                              label="label"
                              :clear-on-select="false"
                              :hide-selected="true"
                              placeholder="Carga Entregue"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                            ></multiselect>
                          </b-col>
                          <b-col sm="6" md="2" class="p-0">
                            <!-- <label>Tabela de frete</label> -->
                            <multiselect
                              v-model="statusCteSelected"
                              :options="optionsStatusCte"
                              track-by="value"
                              label="label"
                              :clear-on-select="false"
                              :hide-selected="true"
                              placeholder="Status CTe Receita"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                            ></multiselect>
                          </b-col>
                          <b-col sm="6" md="2">
                            <div
                                class="fl-flex-label fl-collapsed fl-background"
                            >
                              <input
                                  type="text"
                                  class="form-control"
                                  v-model="form.num_nf"
                              />
                              <label
                                  class="fl-label"
                                  for="default-input"
                                  style="left: 13px; right: 12px"
                              >N° NF</label
                              >
                            </div>
                          </b-col>
                          <b-col sm="6" md="4" class="p-0">
                            <multiselect
                              v-model="transportadoraSelected"
                              :options-limit="300"
                              :limit="2"
                              :limit-text="limitText"
                              :options="optionsTransportadora"
                              track-by="value"
                              label="label"
                              id="transportadora"
                              :hide-selected="true"
                              placeholder="Transportadora ( Digite 3 caracteres para pesquisar )"
                              tag-placeholder="Selecionar"
                              select-label="Selecionar"
                              selected-label="Selecionado"
                              deselect-label="Remover"
                              :searchable="true"
                              :loading="isLoadingTransportadora"
                              @search-change="listaTransportadora"
                            ></multiselect>
                          </b-col>
                          <b-col sm="6" md="2">
                            <div
                              class="fl-flex-label fl-collapsed fl-background"
                            >
                              <input
                                type="text"
                                class="form-control"
                                v-model="form.num_cte"
                              />
                              <label
                                class="fl-label"
                                for="default-input"
                                style="left: 13px; right: 12px"
                                >N° Doc Receita</label
                              >
                            </div>
                          </b-col>
                          <b-col m="6" md="3">
                            <div
                              class="fl-flex-label fl-collapsed fl-background"
                            >
                              <input
                                type="text"
                                class="form-control"
                                v-model="form.cnpj"
                              />
                              <label
                                class="fl-label"
                                for="default-input"
                                style="left: 13px; right: 12px"
                                >CNPJ</label
                              >
                            </div>
                          </b-col>
                        </b-row>
                        <h6 class="mt-1">Dados Complementares:</h6>
                        <b-row no-gutters>
                          <b-col>
                            <b-form-checkbox
                              v-model="form.averbacao"
                              value="1"
                              unchecked-value="2"
                            >
                              Averbação
                            </b-form-checkbox>
                          </b-col>
                          <b-col>
                            <b-form-checkbox
                              v-model="form.despesa_cte"
                              value="1"
                              unchecked-value="2"
                            >
                              Despesa CTe
                            </b-form-checkbox>
                          </b-col>
                          <b-col>
                            <b-form-checkbox
                              v-model="form.fatura"
                              value="1"
                              unchecked-value="2"
                            >
                              Fatura
                            </b-form-checkbox>
                          </b-col>
                          <b-col>
                            <b-form-checkbox
                              v-model="form.mdfe_romaneio"
                              value="1"
                              unchecked-value="2"
                            >
                              Manifesto/Romaneio
                            </b-form-checkbox>
                          </b-col>
                          <b-col>
                            <b-form-checkbox
                              v-model="form.notas_fiscais"
                              value="1"
                              unchecked-value="2"
                            >
                              Notas Fiscais
                            </b-form-checkbox>
                          </b-col>
                          <b-col>
                            <b-form-checkbox
                              v-model="form.ocorrencias"
                              value="1"
                              unchecked-value="2"
                            >
                              Ocorrências
                            </b-form-checkbox>
                          </b-col>
                          <b-col>
                            <b-form-checkbox
                              v-model="form.parceira_comissao"
                              value="1"
                              unchecked-value="2"
                            >
                              Parceira/Comissão
                            </b-form-checkbox>
                          </b-col>
                          <b-btn
                            @click="doGerar(1)"
                            variant="secondary"
                            :disabled="isDisabled"
                          >
                            Extrair
                          </b-btn>
                          <b-btn @click="doLimpar(1)" variant="secondary">
                            Limpar
                          </b-btn>
                          <AvisoErros
                            v-bind:errors_array="errors_array"
                          ></AvisoErros>
                        </b-row>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import AvisoErros from "../../components/AvisoErros";
import accounting from "accounting";

export default {
  components: {
    AvisoErros,
  },
  data() {
    return {
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      loading: false,
      isDisabled: false,
      loadingData: false,
      isFullscreen: false,
      showModal: false,
      errors_array: [],
      unidades: [],

      origemSelected: [],
      optionsMunicipio: [],
      destinoSelected: [],
      faturaSelected: [],
      tpOperacaoSelected: [],
      tpProcessoSelected: [],
      optionsLivStatusFatura: [],
      optionsLivTpOperacao: [],
      optionsLivTpProcesso: [],
      statusCargaSelected: [],
      unidades2: [
        {
          descr: "Unidades",
          unidade: [],
        },
      ],
      optionsStatusCarga: [],
      statusCteSelected: [],
      optionsStatusCte: [],
      transportadoraSelected: [],
      optionsTransportadora: [],
      optionsTabelaFreteRepopulada: [
        { label: "exemplo", value: 1 },
        { label: "exemplo 2", value: 2 },
      ],
      helpForm: new Form({ statusRecord: [], params: [], search: "" }),
      isLoadingTransportadora: false,
      form: new Form({
        dt_ini: "",
        dt_fim: "",
        dt_expedicao_ini: "",
        dt_expedicao_fim: "",
        num_nf: "",
        num_cte: "",
        cnpj: "",
        averbacao: "",
        despesa_cte: "",
        fatura: "",
        mdfe_romaneio: "",
        notas_fiscais: "",
        ocorrencias: "",
        parceira_comissao: "",
        origem: "",
        destino: "",
        tp_processo: "",
        tp_operacao: "",
        status_fatura: "",
        status_carga: "",
        status_cte: "",
        unidades: [],
        pessoa_id: "",
      }),
    };
  },
  watch: {
    origemSelected(obj) {
      this.form.origem = obj.value;
    },
    destinoSelected(obj) {
      this.form.destino = obj.value;
    },
    faturaSelected(obj) {
      this.form.status_fatura = obj.value;
    },
    tpOperacaoSelected(obj) {
      this.form.tp_operacao = obj.value;
    },
    tpProcessoSelected(obj) {
      this.form.tp_processo = obj.value;
    },
    statusCargaSelected(obj) {
      this.form.status_carga = obj.value;
    },
    statusCteSelected(obj) {
      this.form.status_cte = obj.value;
    },
    transportadoraSelected(obj) {
      this.form.pessoa_id = obj.value;
    },
  },
  mounted() {
    this.getLivGeral();
  },
  methods: {
    doGerar() {
      this.loading = true;
      this.isDisabled = true;
      this.unidades.forEach((obj) => {
        this.form.unidades.push(obj.value);
      });
      this.form
        .post("/api/relatorio/relatoriofreterecebidoexpedido")
        .then((response) => {
          new ReturnApi(response, this);
          this.errors_array = "";
          this.errors_array = [];
          this.form.unidades = [];
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
          this.errors_array = "";
          this.errors_array = [];
          this.form.unidades = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    doLimpar() {
      this.form.dt_ini = "";
      this.form.dt_fim = "";
      this.form.dt_expedicao_ini = "";
      this.form.dt_expedicao_fim = "";
      this.form.num_nf = "";
      this.form.num_cte = "";
      this.form.pessoa_id = "";
      this.form.cnpj = "";
      this.form.averbacao = "";
      this.form.despesa_cte = "";
      this.form.fatura = "";
      this.form.mdfe_romaneio = "";
      this.form.notas_fiscais = "";
      this.form.ocorrencias = "";
      this.form.parceira_comissao = "";
      this.form.origem = "";
      this.form.destino = "";
      this.form.tp_operacao = "";
      this.form.tp_processo = "";
      this.form.status_fatura = "";
      this.form.status_carga = "";
      this.form.status_cte = "";
      this.origemSelected = [];
      this.destinoSelected = [];
      this.faturaSelected = [];
      this.tpOperacaoSelected = [];
      this.tpProcessoSelected = [];
      this.statusCargaSelected = [];
      this.statusCteSelected = [];
      this.unidades2[0].unidades = [];
      this.unidades = [];
      this.form.unidades = [];
    },
    listaTransportadora(search) {
      if (search.length >= 3) {
        this.isLoadingTransportadora = true;
        this.helpForm.search = search;
        this.helpForm.status = 1;
        this.helpForm
          .post("/api/pessoa/jsonlist/transportadora")
          .then((response) => {
            this.optionsTransportadora = [];
            new ReturnApi(response, this, true, false, false);
            if (response.items.length > 0) {
              response.items.forEach((obj) => {
                this.optionsTransportadora.push({
                  label:
                    "PJ -" +
                    obj.pessoa.cd +
                    " - " +
                    obj.razao_social +
                    " - " +
                    this.onFormataCnpj(
                      obj.cnpj_base,
                      obj.cnpj_filial,
                      obj.cnpj_digito
                    ).replace(
                      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                      "$1.$2.$3/$4-$5"
                    ) +
                    " - " +
                    obj.inscricao_estadual,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsF.length > 0) {
              response.itemsF.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PF -" + obj.nome + " - " + obj.cpf,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            if (response.itemsE.length > 0) {
              response.itemsE.forEach((obj) => {
                this.optionsTransportadora.push({
                  label: "PE -" + obj.nome + " - " + obj.cd,
                  pessoa_id: obj.pessoa_id,
                  value: obj.pessoa_id,
                });
              });
            }
            this.isLoadingTransportadora = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
      }
    },
    getLivGeral() {
      this.helpForm
        .get("/api/relatorio/relatoriofreterecebidoexpedido/jsonlistgeral")
        .then((response) => {
          new ReturnApi(response, this, true, false, false);
          response.status_fatura.forEach((obj) => {
            this.optionsLivStatusFatura.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.tp_operacao.forEach((obj) => {
            this.optionsLivTpOperacao.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.tp_processo.forEach((obj) => {
            this.optionsLivTpProcesso.push({
              label: obj.descr,
              value: obj.valor,
            });
          });
          response.unidade.forEach((obj) => {
            this.unidades2[0].unidade.push({
              label: obj.descr,
              value: obj.unidade_id,
            });
          });
            response.municipio.forEach((obj) => {
              this.optionsMunicipio.push({
                label: obj.nome + " - " + obj.uf.cd,
                value: obj.municipio_id,
              });
            });
          //Cria as opcoes sem liv
          this.optionsStatusCarga.push({ label: "Sim", value: 1 });
          this.optionsStatusCarga.push({ label: "Não", value: 2 });
          this.optionsStatusCte.push({ label: "Pagos", value: 1 });
          this.optionsStatusCte.push({ label: "Cancelados", value: 2 });
          this.optionsStatusCte.push({ label: "Todos", value: 3 });
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
      var cnpj_formatado;
      var pad = "00000000";
      var cnpj_base =
        pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
      var pad = "0000";
      var cnpj_filial =
        pad.substring(0, pad.length - cnpj_filial.toString().length) +
        cnpj_filial;
      var pad = "00";
      var cnpj_digito =
        pad.substring(0, pad.length - cnpj_digito.toString().length) +
        cnpj_digito;
      return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm").format(fmt);
    },
    expandFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.getters.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
